import S from 'string';
import { v1 as uuid } from 'uuid';

export default class TableUtils {
    static isEmpty(value) {
        if (Array.isArray(value)) {
            // eslint-disable-next-line no-restricted-syntax
            for (const item of value) {
                if (S(item).isEmpty()) {
                    return true;
                }
            }

            return false;
        }

        return S(value).isEmpty();
    }

    static generateUUID() {
        return uuid();
    }

    static checkIfLoadMoreRecords(target, records, totalCount, loading) {
        const scrollTopOffset = 25;
        const currentScrollPosition = Math.ceil(target.offsetHeight + target.scrollTop);
        const maximumScrollPosition = target.scrollHeight;

        return currentScrollPosition >= (maximumScrollPosition - scrollTopOffset)
                        && records.length < totalCount
                        && !loading;
    }
}
